// src/App.js - Yalnızca landing sayfası (giriş/panel erişimi kapatıldı)
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Landing from './pages/Landing';

// Global Styles
import './styles/global.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <main>
                <Landing />
              </main>
            }
          />
          {/* Giriş kaldırıldı. Eski bağlantılar (/login, /dashboard, /admin ...)
              ana sayfaya yönlendirilir; auth/user/admin sayfaları diskte duruyor
              ama hiçbir route'tan erişilemiyor. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
